module.exports = __webpack_public_path__ + "img/wyse-logo.fc10ad83.png";